module.exports = "<div id=\"sps-intercom-root\"></div>\n";